import { DoorOpen as icon } from "lucide-react"
import create from "./rooms.create"
import edit from "./rooms.edit"

import { RoomRecord } from "./rooms.types"

const crud = (permissions: Record<string, string[]>) => ({
  name: "rooms",
  options: { label: "Rooms" },
  create:
    "rooms" in permissions && permissions.rooms.includes("create")
      ? create
      : undefined,
  edit:
    "rooms" in permissions && permissions.rooms.includes("edit")
      ? edit
      : undefined,
  icon,

  recordRepresentation: (record: RoomRecord): string => record.title,
})

export default crud
